import { render, staticRenderFns } from "./MiniGameWrite.vue?vue&type=template&id=6fca7f2c&scoped=true&"
import script from "./MiniGameWrite.vue?vue&type=script&lang=js&"
export * from "./MiniGameWrite.vue?vue&type=script&lang=js&"
import style0 from "./MiniGameWrite.vue?vue&type=style&index=0&id=6fca7f2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fca7f2c",
  null
  
)

export default component.exports